import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { showErrorToast, showSuccessToast } from "#app/notifications";
import { ClientDto } from "#modules/clients/infra/Client.dto";
import { clientsQuery } from "#modules/clients/infra/clients.query";
import { createClient } from "#modules/clients/infra/createClient.api";
import { quoteRequestsQuery } from "#modules/quoteRequests/infra/quoteRequests.query";

export const useCreateClient = ({
  options = { shouldShowSuccessToast: true },
}: {
  options?: {
    onSuccess?: (data: ClientDto) => void;
    handleSetClient?: (clientId: string) => void;
    shouldShowSuccessToast?: boolean;
  };
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, ...rest } = useMutation({
    mutationFn: createClient,
    onSuccess: (data) => {
      void queryClient.invalidateQueries(quoteRequestsQuery());
      void queryClient.invalidateQueries(clientsQuery());

      if (options.shouldShowSuccessToast) {
        showSuccessToast({ title: t("client.create.success") });
      }

      if (options.onSuccess && data) {
        options.onSuccess(data);
      }
    },
    onError: () => {
      showErrorToast({
        title: t("common.error"),
        message: t("client.create.error"),
      });
    },
  });

  return { createClient: mutate, createClientAsync: mutateAsync, ...rest };
};
